// VOORBEELD – vervangen voor livegang
// Laat een "X mensen bekijken dit nu"-getal rustig binnen een bandbreedte
// schommelen. Geen echte meting, puur sfeer/urgentie.
class SkigrinViewers extends HTMLElement {
  connectedCallback() {
    this.min = parseInt(this.dataset.min, 10) || 1;
    this.max = Math.max(parseInt(this.dataset.max, 10) || this.min, this.min);
    this.countEl = this.querySelector('[data-count]');
    if (!this.countEl) return;

    this.value = this.randomInRange(this.min, this.max);
    this.render();

    this.timer = setInterval(() => this.step(), this.randomDelay());
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  randomInRange(min, max) {
    return Math.round(min + Math.random() * (max - min));
  }

  randomDelay() {
    // tussen de 18 en 42 seconden tot de volgende kleine schommeling
    return 18000 + Math.random() * 24000;
  }

  step() {
    const delta = Math.random() < 0.5 ? -1 : 1;
    let next = this.value + delta * (Math.random() < 0.7 ? 1 : 2);
    next = Math.min(this.max, Math.max(this.min, next));
    this.value = next;
    this.render();

    clearInterval(this.timer);
    this.timer = setInterval(() => this.step(), this.randomDelay());
  }

  render() {
    this.countEl.textContent = this.value;
  }
}

customElements.define('skigrin-viewers', SkigrinViewers);
